import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
import { getDataByUrl } from "@/handlers/commonApi";
import useIsMobile from "@/hooks/useIsMobile";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  // faqData = null,
  constituencyListData = null,
}) {
  const isMobileDevice = useIsMobile();
  let metaData = {
    title: `Kerala Election 2026 Date: केरल विधानसभा चुनाव की तारीख़, चरणवार वोटिंग और रिजल्ट शेड्यूल - NewsTak`,
    description: `Kerala Chunav 2026 Schedule: जानें केरल विधानसभा चुनाव 2026 की वोटिंग डेट, चरणवार मतदान का पूरा शेड्यूल, नतीजे कब आएंगे और नामांकन की तारीख़ें, पढ़ें Kerala Election 2026 से जुड़ी हर अपडेट सिर्फ NewsTak पर.`,
    keywords: `Kerala election 2026 date, Kerala election schedule 2026, Kerala vidhan sabha chunav 2026, Kerala voting date 2026, Kerala election result date, Kerala chunav phase 1 2026, Kerala chunav phase 2 2026, Kerala election news 2026, केरल चुनाव 2026 तारीख, केरल विधानसभा चुनाव शेड्यूल`,
  };

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}
          // electionPath={"delhi-assembly/schedule"}
          electionPath={`${electionCategory}/schedule`}

          isMobileDevice={isMobileDevice}
          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="kerala_election"
          stateName={"Kerala"} //"Delhi"
          stateHindi={"केरल"}
          metaData={metaData}
          constituencyListData={constituencyListData}
          staticContent="चुनाव आयोग ने केरल विधानसभा चुनाव का ऐलान कर दिया है. राज्य की 140 सीटों पर इस बार एक ही चरण में मतदान की प्रक्रिया पूरी कराई जाएंगी. केरल विधानसभा चुनाव के लिए 9 अप्रैल को वोट डाले जाएंगे और फिर 4 मई को वोटों की गिनती होगी, जिसके बाद परिणाम सामने आएंगे. चुनाव के शेड्यूल जारी करने के बाद आयोग ने 16 मार्च को गजट नोटिफिकेशन जारी कर दिया, जिसके तहत उम्मीदवार 23 मार्च तक अपना नामांकन करा सकते है. वहीं 24 मार्च को इन पत्रों की जांच की जाएगी. वहीं 26 मार्च, 2026 तक प्रत्याशी अपना नामांकन वापस ले सकते है."
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/schedule")[0];

  let electionCategory = url.split("/elections/")[1];

  try {
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let electionConfigData = null;
    const electionConfig = await fetch(
      `${process.env.BASE_PATH + process.env.API_PREFIX
      }/masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.kerala_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
        ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    });

    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory: electionCategory,
        // faqData,
        constituencyListData
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
